import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { APP_DATE_FORMATS } from '../../service/date.adapter';

const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();
@Component({
  selector: 'kt-date-picker',
  templateUrl: './date-picker.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
  ]
})
export class DatePickerComponent {
  @Output() valueChange = new EventEmitter();
  datePicker: any;
  firstDay: Date;
  lastDay: Date;
  minDate: any;
  ngOnInit() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); 

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    this.datePicker = new FormGroup({
      start: new FormControl(firstDay, [Validators.required]),
      end: new FormControl(lastDay, [Validators.required]),
    });
    this.minDate = this.datePicker.controls.start.value;
    this.valueChange.emit({
      fromDt: this.datePicker.controls['start'].value,
      toDt: this.datePicker.controls['end'].value
    });
  }
  viewReport(form:any) {
    if (form.valid) {
      this.valueChange.emit({
        fromDt: form.controls['start'].value,
        toDt: form.controls['end'].value
      });
    }
  }


  onValueChange(event: any, form:any) {
    const startMonth = form.controls.start.value._d.getMonth();
    const startYear = form.controls.start.value._d.getFullYear();
    const lastDayOfMonth = new Date(startYear, startMonth + 1, 0);
    this.datePicker.controls.end.setValue(lastDayOfMonth);
    // form.controls.end.reset();
    this.minDate = form.controls.start.value._d;
  }
}
